import React from "react";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import { PackageVariant } from "@directv-digital/dds.ui.plan-cards.utils";
import { fusionScrollBarStyles } from "@directv-digital/dds.core.commons";

export interface PackageCardWrapperProps {
  id: string;
  orientation: string;
  length: number;
  packageCardVariant: string;
  mduVariant: boolean | undefined;
  children: React.ReactNode;
}

export const PackageCardWrapper: React.FC<PackageCardWrapperProps> = ({
  id,
  orientation,
  length,
  packageCardVariant,
  mduVariant,
  children
}) => (
      <DtvBox id={id}
        sx={{
          mx: {
            xs: 2.5,
            sm: 5.5,
            md: 17.5,
            lg: 32.5,
            xl: 42.5
          },
          padding: "0 10px",
          overflow: { xs: packageCardVariant !== PackageVariant.v2 ? 'auto' : 'hidden' },
          overflowX:
            orientation === "horizontal" ? "visible" :
            length > 1 && packageCardVariant !== PackageVariant.v2 ? "auto" :
            { sm: "auto" },
          overflowY: orientation === "horizontal" ? "visible" : 'hidden',
          ...fusionScrollBarStyles("20px", "24px"),
          ...(mduVariant && {
            display: "flex",
            justifyContent: "center"
          })
      }}>
        <DtvBox
          sx={{
            width: orientation === "horizontal" ? "100%" : {
              xs: length > 1 && packageCardVariant !== PackageVariant.v2 ?
                `calc(${length} * 75%)` :
                "100%",
              sm: length > 2 ?
                ((mduVariant && "100%") || (`calc(${length} * 37.5%)`)) :
                "100%",
              md: "100%",
              lg: "100%",
              xl: "100%"
            },
            padding: { sm: "0 10px" }
          }}>
          <DtvBox
            sx={{
              display: "flex",
              width: "100%",
              gap: 5,
              justifyContent: "center",
              ...(packageCardVariant === PackageVariant.v2 && {
                flexDirection: {
                  xs: "column",
                  sm: orientation === "horizontal" ? "column" : "row",
                  md: orientation === "horizontal" ? "column" : "row"
                }
              })
          }}>
            {children}
          </DtvBox>
        </DtvBox>
      </DtvBox>
);
